<template>
    <div id="app" class="container mx-auto h-full">
        <div class="flex inline-block justify-center h-full text-center">
            <div class="mb-auto mt-auto uppercase">
                <div class="text-5xl lg:text-6xl md:text-6xl sm:text-5xl tracking-tight font-bold leading-10 mb-0 px-4 sm:mb-1">
                    Drop<span class="font-black">ware</span>
                </div>
                <span class="text-sm lg:text-xl md:text-sm sm:text-sm text-xs tracking-widest font-medium -mr-2 leading-10">
                    <vue-typer :text="['Shop', 'Drop']" erase-style='backspace' :erase-delay='150' :pre-type-delay='500'></vue-typer>
                    it like it's hot
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { VueTyper } from 'vue-typer';

export default {
  name: 'app',
  components: {
      VueTyper
  },
};
</script>
